import { ShapeIcon, ShapeIconOptions } from "@flash-tecnologia/hros-web-ui-v2";
import styled, { css, RuleSet } from "styled-components";
import PillSelect from "@flash-tecnologia/flamingo-ui-pill-select";

const SUPPORTED_SHAPE_ICON_HOVERS: Partial<
  Record<ShapeIconOptions, RuleSet<object>>
> = {
  success: css`
    &:hover {
      border: ${({ theme }) =>
        `${theme.borders.width.xs2} solid ${theme.colors.feedback.success[50]}`};
    }
  `,
  error: css`
    &:hover {
      border: ${({ theme }) =>
        `${theme.borders.width.xs2} solid ${theme.colors.feedback.error[50]}`};
    }
  `,
} as const;

export const VerticalStepsGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: start;
  grid-column-gap: ${({ theme }) => theme.spacings.xs4};
  padding: 0 ${({ theme }) => theme.spacings.xs4};
`;

export const StepState = styled.div<{ isFirst?: boolean; isLast?: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 1;

  &::before {
    content: "";
    position: absolute;
    width: ${({ theme }) => theme.borders.width.xs2};
    background-color: ${({ theme }) => theme.colors.neutral[90]};
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;

    ${({ isFirst, isLast }) => {
      if (isFirst && !isLast)
        return css`
          top: 50%;
          bottom: 0;
        `;
      if (isLast && !isFirst)
        return css`
          top: 0;
          bottom: 50%;
        `;

      if (!isFirst && !isLast)
        return css`
          top: 0;
          bottom: 0;
        `;
    }}
  }
`;

export const StepContent = styled.div`
  padding: ${({ theme }) => theme.spacings.xs3} 0;
`;

export const ShapeIconHoverable = styled(ShapeIcon)`
  ${({ variant }) => SUPPORTED_SHAPE_ICON_HOVERS[variant] ?? ""}

  &:focus-visible,
  &:active {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.secondary[90]};
  }
`;

export const StepperTrigger = styled(PillSelect.Trigger)`
  width: 320px;
`;
